import { GoogleAnalytics } from './google-analytics';

export function analyticsFromActionsMiddleware() {
  return store => next => action => {
    if (action && action.analytics && action.analytics.eventName) {
      const { eventName, eventParams } = action.analytics;
      const googleAnalytics = new GoogleAnalytics();
      googleAnalytics.logEventWithParamaters(eventName, eventParams);
    }
    return next(action);
  };
}
